import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getProviderTransferCompanyDetailFetchSuccess,
    getProviderTransferCompanyDetailFetchFailure,
    createProviderTransferCompanyDetailFetchSuccess,
    createProviderTransferCompanyDetailFetchFailure,
    updateProviderTransferCompanyDetailFetchSuccess,
    updateProviderTransferCompanyDetailFetchFailure,
    deleteProviderTransferCompanyFetchSuccess,
    deleteProviderTransferCompanyFetchFailure,
} from './reducer';
import { ProviderTransferCompanyDetailResType } from 'src/types/providerTransferCompanyDetail';
import { ProviderTransferCompanyType } from 'src/types/providerTransferCompany';
import translate from '@translate';

const getProviderTransferCompanyDetailFetchRequest = async (idProviderTransferCompany: string) => {
    const res = await api('get', `api/secure/provider-transfer-companies/${idProviderTransferCompany}`);
    return res.data;
};

function* getProviderTransferCompanyDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ProviderTransferCompanyDetailResType = yield call((): any =>
            getProviderTransferCompanyDetailFetchRequest(action.payload)
        );
        yield put(getProviderTransferCompanyDetailFetchSuccess(response));
    } catch (error) {
        yield put(getProviderTransferCompanyDetailFetchFailure({ error }));
    }
}

export function* getProviderTransferCompanyDetailFetchWatch() {
    yield takeEvery('providerTransferCompanyDetail/getProviderTransferCompanyDetailFetch', getProviderTransferCompanyDetailFetch);
}

const createProviderTransferCompanyDetailFetchRequest = async (data: ProviderTransferCompanyType) => {
    const res = await api('post', 'api/secure/provider-transfer-companies', data);
    return res.data;
};

function* createProviderTransferCompanyDetailFetch(action: { type: string; payload: ProviderTransferCompanyType }) {
    try {
        const response: ProviderTransferCompanyDetailResType = yield call((): any =>
            createProviderTransferCompanyDetailFetchRequest(action.payload)
        );
        yield put(
            createProviderTransferCompanyDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providerTransferCompanyDetail.message.providerTransferCompanyCreated') },
            })
        );
    } catch (error) {
        yield put(createProviderTransferCompanyDetailFetchFailure({ error }));
    }
}

export function* createProviderTransferCompanyDetailFetchWatch() {
    yield takeEvery('providerTransferCompanyDetail/createProviderTransferCompanyDetailFetch', createProviderTransferCompanyDetailFetch);
}

const updateProviderTransferCompanyDetailFetchRequest = async (params: {
    idProviderTransferCompany: string;
    data: ProviderTransferCompanyType;
}) => {
    const res = await api('put', `api/secure/provider-transfer-companies/${params.idProviderTransferCompany}`, params.data);
    return res.data;
};

function* updateProviderTransferCompanyDetailFetch(action: {
    type: string;
    payload: { idProviderTransferCompany: string; data: ProviderTransferCompanyType };
}) {
    try {
        const response: ProviderTransferCompanyDetailResType = yield call((): any =>
            updateProviderTransferCompanyDetailFetchRequest(action.payload)
        );
        yield put(
            updateProviderTransferCompanyDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providerTransferCompanyDetail.message.providerTransferCompanyUpdate') },
            })
        );
    } catch (error) {
        yield put(updateProviderTransferCompanyDetailFetchFailure({ error }));
    }
}

export function* updateProviderTransferCompanyDetailFetchWatch() {
    yield takeEvery('providerTransferCompanyDetail/updateProviderTransferCompanyDetailFetch', updateProviderTransferCompanyDetailFetch);
}

const deleteProviderTransferCompanyFetchRequest = async (idProviderTransferCompany: string) => {
    const res = await api('delete', `api/secure/provider-transfer-companies/${idProviderTransferCompany}`);
    return res.data;
};

function* deleteProviderTransferCompanyFetch(action: { type: string; payload: string }) {
    try {
        const response: ProviderTransferCompanyDetailResType = yield call((): any =>
            deleteProviderTransferCompanyFetchRequest(action.payload)
        );
        yield put(
            deleteProviderTransferCompanyFetchSuccess({
                ...response,
                messageSuccess: { title: translate('providerTransferCompanyDetail.message.providerTransferCompanyDeleted') },
            })
        );
    } catch (error) {
        yield put(deleteProviderTransferCompanyFetchFailure({ error }));
    }
}

export function* deleteProviderTransferCompanyFetchWatch() {
    yield takeEvery('providerTransferCompanyDetail/deleteProviderTransferCompanyFetch', deleteProviderTransferCompanyFetch);
}
